var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.currentCohort.es_cohortid + 'grades-page',staticClass:"grades-component"},[_c('grades-name'),_c('grades-percentages'),_c('grades-chart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }